import * as React from "react";
import logo from "../../../assets/img/logo-1.png";
import { Link, useNavigate } from "react-router-dom";
import styleForgetPassword from "./ForgetPassword.module.css";
import InputElement from "../../form/InputElement";
import { forgotPassowrd } from "../../../adapters/apis/auth/auth";
import Footer from "../../../layouts/footer/Footer";
function ForgetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [errMessage, setErrMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  function handleChange(parentCompenent, compenent, key, value) {
    setEmail(value);
  }
  function forgetPassword() {
    setMessage("");
    setErrMessage("");
    setLoading(true);

    forgotPassowrd({ email: email })
      .then((res) => {
        if (res.data.code == 422) {
          setErrMessage(res.data.status);
          setLoading(false);
        } else if (res.data.code == 200) {
          setMessage(res.data.status);
          navigate(`/mail-verified?email=${email}`);
          setLoading(false);
        }
      })
      .catch((error) => {
        setErrMessage(error.response.data.message);
        setLoading(false);
      })
      .finally();
  }
  return (
    <>
      <section className={styleForgetPassword["forget-password-section"]}>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-md-5">
              <div className={`card ${styleForgetPassword["card"]}`}>
                <div className="text-center">
                  <Link to="/">
                    <img src={logo} alt="Logo" />
                  </Link>
                  <div className="mt-5">
                    <ul class="nav  justify-content-center fs-6 border-0">
                      <li class="nav-item">
                        <Link
                          to="/forget-password-phone"
                          className={`${styleForgetPassword.bgGrey} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          رقم الهاتف المحمول
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link
                          to="/forget-password"
                          className={`${styleForgetPassword.bgCustom} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          البريد الإلكترونى
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {message && (
                  <div className="alert alert-primary mt-4" role="alert">
                    {message}
                  </div>
                )}
                <div
                  className={`${styleForgetPassword["card-body"]} card-body mt-5 mb-4`}
                >
                  <InputElement
                    allowedPattern={/^[A-Za-z0-9._@-]{1,100}$/}
                    mb4="mb-4"
                    name="email"
                    labelHtmlFor="email"
                    labelClassName={` required ${styleForgetPassword["form-label"]} form-label`}
                    labelText="البريد الإلكترونى"
                    inputType="mobile"
                    inputClassName={`${styleForgetPassword["form-control"]} form-control`}
                    inputID="email"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={email}
                    onChange={handleChange}
                    pText={errMessage}
                  />
                  <div
                    className={`${styleForgetPassword["login-btn"]} text-center my-5`}
                  >
                    <button
                      onClick={forgetPassword}
                      id="set_new_password_button"
                      className={`${styleForgetPassword["btn-login"]} mb-4 d-block`}
                      disabled={loading}
                    >
                      إرسال بريد إعادة تعيين كلمة المرور
                    </button>
                    <button
                      onClick={() => navigate("/login")}
                      id="back_to_login_button"
                      className={`${styleForgetPassword["btn-bkToLogin"]} mb-4 d-block`}
                    >
                      العودة إلى شاشة تسجيل الدخول
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ForgetPassword;
